import { NotFoundPage } from '@axilon-apps/libs-ui-dashboard'
import { useGetAuthzMeQuery } from '@axilon-apps/domains-ontology-ui-state'
import { isGlobalAdmin } from '../../lib/global-admin'

interface GlobalAdminRouteProps {
  children: React.ReactNode
  /** Where to send users who are not global admins. */
  fallbackHref?: string
}

/**
 * Renders `children` only for global admins; everyone else gets the standard
 * `NotFoundPage`. Renders nothing while authz loads so admins don't see a
 * flash of 404.
 */
export function GlobalAdminRoute({ children, fallbackHref = '/chat' }: GlobalAdminRouteProps) {
  const { data: authz, isLoading } = useGetAuthzMeQuery()
  if (isLoading) return null
  if (!isGlobalAdmin(authz?.roles)) return <NotFoundPage href={fallbackHref} />
  return children
}

export default GlobalAdminRoute
